import { getLocale } from '@/i18n/locale';
import { isResortWithoutWeSki } from '@/util/isResortWithoutWeSki';
import { isRegionWithoutWeSki } from '@/util/isRegionWithoutWeSki';
import { weSkiDestinationId } from './PlanYourTrip/WeSki/resolver';
import { getWeskiPartnerId } from './PlanYourTrip/WeSki/WeSkiWidget';

interface IProps {
  id: string;
  isRegion:boolean;
}

const WeskiWisepopsPopupDiv = ({ id, isRegion }:IProps) => {
  const destinationId = weSkiDestinationId(isRegion ? { regionId: id } : { resortId: id });
  const locale = getLocale();
  const shouldHideWeSki = isResortWithoutWeSki(id, locale) || isRegionWithoutWeSki(id, locale);

  if (shouldHideWeSki) {
    return null;
  }

  if (!destinationId) {
    return null;
  }

  return (
    <div id="weski-widget" data-mobile-modal-only="true" data-partner={getWeskiPartnerId()} data-destination-id={destinationId} data-new-tab="true" />
  );
};

export default WeskiWisepopsPopupDiv;
